import React from "react";
import { useNavigate } from "react-router-dom";

const CampaignCancelled = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>
        <span role="img" aria-label="cancelled">❌</span> Payment Cancelled
      </h2>
      <p style={styles.text}>
        It looks like you cancelled your payment. No problem!
      </p>
      <p style={styles.text}>
        You can restart the process at any time to launch your campaign.
      </p>
      <button style={styles.button} onClick={() => navigate("/campaigns")}>
        Try Again
      </button>
    </div>
  );
};

const styles = {
  container: {
    padding: "2rem",
    textAlign: "center",
    maxWidth: "600px",
    margin: "60px auto",
    background: "#fff5f5",
    borderRadius: "12px",
  },
  heading: {
    fontSize: "1.8rem",
    marginBottom: "1rem",
    color: "#d32f2f",
  },
  text: {
    fontSize: "1rem",
    color: "#333",
    marginBottom: "0.8rem",
  },
  button: {
    backgroundColor: "#f06292",
    color: "white",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    fontSize: "1rem",
    cursor: "pointer",
    marginTop: "1rem",
  },
};

export default CampaignCancelled;